<template>
	<div id="Received">
		<div class="g-right-top width800">个人中心／编辑资料／基本信息</div>
		<div class="g-right-middle margintop20 width800">
			<div class="wdfb-list " v-for='(item,key) in list' :key='item.id' v-if="item.praise_role.state===3 ? isshow : !isshow ">
				<p >
					<router-link  :to="'/juzucontent/'+item.praise_crew.id" >
						<div class="float-left">
							<i class="email-icon"></i>
							<span style="padding-left: 20px;">报名角色：{{item.praise_crew.movie_name}}中的{{item.nature}}:{{item.praise_role.role_name}}</span>
						</div>
					</router-link>
					<div class="float-right" style="width: 140px;">
						<span style="width:100px">{{item.create_time}}</span>
						<span @click="del_list(key,item.id)" style="margin-top: 4px;" class="el-icon-delete float-right"></span>
					</div>
					<div class="clearfix"></div>

				</p>
				<span v-if=""
			</div>
		</div>
	</div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../storage/storage.js'
	export default {
		data() {
			return {
				list: [],
				id: '',
				modal2: false,
				modal_loading: false,
				isshow:false,
			}
		},
		methods: {
			getdata() {
				var api = 'https://api.yopoo.cn/api/centre/getpraise?page=1&count=10&state=1'
				let token = storage.get('token')
				Axios.get(api, {
					headers: {
						'Authorization': token
					}
				}).then((res) => {
						this.list = res.data
						for(var i=0;i<this.list.length;i++){
							var state=this.list[i].praise_role.state;
							if(state=='3'){
								$(function(){
									$('.state').attr('disabled',"true");//jq方法禁用认证弹窗
								})
							}
						}
					},
					(err) => {
						console.log(err)
					})
			},
			del_list(key, id) {
				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {
						var api = 'https://api.yopoo.cn/api/centre/delepraise?state=1&id=' + id
						
						let token = storage.get('token')
						
						Axios.get(api, {
								headers: {
									'Authorization': token
								}
							}).then((res) => {
								this.list.splice(key, 1) //实际删除内容的索引
								this.list.splice(id, 1) //实际删除内容的后台id,但删除的内容是key
								this.$message({ //提示信息
								message: res.data.msg,
								type: 'success',
								center: true
							});
						})
					},
					onCancel: () => {
						// this.$Message.info('点击了取消');
					},
				})
			}
		},
		mounted() {
			this.getdata()
			
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/per_admin/P_Received.vue